import { useEffect, useState } from 'react';
import { getAdvertiserTos } from '../services/getAdvertiserTos';
import { getHostAgreement } from '../services/getHostAgreement';

const FETCHERS = {
    advertiser_tos: getAdvertiserTos,
    host_agreement: () => getHostAgreement()
};

export function useLegalDocument(documentKey) {
    const [doc, setDoc] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        const fetcher = FETCHERS[documentKey];
        if (!fetcher) {
            setDoc(null);
            setError(documentKey ? 'Unknown document' : null);
            setLoading(false);
            return undefined;
        }

        setLoading(true);
        setError(null);
        fetcher()
            .then((res) => {
                if (cancelled) return;
                if (res.data?.success) {
                    setDoc({
                        title: res.data.title,
                        body: res.data.body,
                        version: res.data.version,
                        updatedAt: res.data.updatedAt,
                        esignNotice: res.data.esignNotice || null
                    });
                } else {
                    setError('Failed to load document');
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setError('Failed to load document');
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [documentKey]);

    return { doc, loading, error };
}
